// removed by extract-text-webpack-plugin
module.exports = {"overlay":"DeclineOverlay__overlay___29sJf","divider":"DeclineOverlay__divider___21Gqu","subheading":"DeclineOverlay__subheading___ExZbN","message":"DeclineOverlay__message___HfvHI","confirm":"DeclineOverlay__confirm___3tQCG","cancel":"DeclineOverlay__cancel___2ddvm","addMessage":"DeclineOverlay__addMessage___1ZqaX","undoOverlay":"DeclineOverlay__undoOverlay___HCEzb"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/employer/projectInformation/components/candidates/DeclineOverlay.scss
// module id = 610
// module chunks = 0